import React, { createElement, useEffect, useRef, useState } from 'react';
import { Button, Icon, Table, Pagination, Message, Loading, Overlay, Balloon } from '@alifd/next';
import { previewDataByField } from '../../../api/common/index';
import { exportData } from '../../../api/table/index';
import TableHeader from './TableHeader';
import { dealFieldByList, dom2image, downloadFile, exportExcel, dealSymbol, getSearchType, } from '../../../utils';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { getTextWidth } from '../../../utils/index';
import { fIsMobile } from '../../../utils';
import { fetchApplication } from '../../../api/report';
const { Popup } = Overlay;
const Tooltip = Balloon.Tooltip;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const appid = urlParams.get('applicationId');
const ITable = (props, ref) => {
    const { dataSource, transposition, cols, theme, paging, pageSize, showSeqNum, fixedColumnlndex, headerBgColor, headerTextColor, hasTitle, titleText, descText, } = props;
    const data = props.data.map((e, i) => ({ ...e, index: i + 1 }));
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [idata, setIdata] = useState([]);
    const [icols, setIcols] = useState([]);
    const [itranspositionData, setItranspositionData] = useState([]);
    const [itranspositionProps, setItranspositionProps] = useState([]);
    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(2);
    const pam = useRef(null);
    const calculateTransposition = () => {
        try {
            let transpositionData = [];
            let transpositionProps = [{ dataIndex: 'title' }];
            const length = idata.length;
            const keys = icols.map((e) => e.dataIndex);
            for (let i = 0; i < keys.length; i++) {
                let obj = {
                    title: icols[i].title,
                };
                for (let j = 0; j < length; j++) {
                    if (i === 0) {
                        transpositionProps.push({
                            dataIndex: j + '',
                        });
                    }
                    obj[j] = idata[j][keys[i]];
                }
                transpositionData.push(obj);
            }
            setItranspositionProps(transpositionProps);
            setItranspositionData(transpositionData);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('行列转置处理异常,请重新配置数据源字段或更新组件');
        }
    };
    const [current, setCurrent] = useState(1);
    const [openRowKeys, setOpenRowKeys] = useState([]);
    const popcell = (text, width) => {
        const popupProps = {
            animation: {
                in: 'zoomIn',
                out: 'zoomOut',
            },
            triggerType: 'hover',
            placementOffset: 4,
        };
        const w = getTextWidth(text) + 32;
        if (w > Number(width?.replace('px', ''))) {
            return (createElement(Popup, Object.assign({}, popupProps, { v2: true, trigger: createElement("div", { className: "popcell" }, text), placement: "t" }),
                createElement("div", { className: "popup" }, text)));
        }
        return text;
    };
    const renderCols = () => {
        return (transposition ? itranspositionProps : icols).map((col, index) => {
            const i = showSeqNum ? index + 1 : index;
            return (createElement(Table.Column, Object.assign({ cell: (text) => popcell(text, col.width) }, col, (fixedColumnlndex > i
                ? {
                    lock: 'left',
                }
                : {}))));
        });
    };
    useEffect(() => {
        setError(false);
        try {
            init(pam.current);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('分页切换异常,请重新配置数据源字段或更新组件');
        }
    }, [dataSource, current, pageSize]);
    useEffect(() => {
        try {
            if (transposition) {
                calculateTransposition();
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('行列转置处理异常,请重新配置数据源字段或更新组件');
        }
    }, [idata, transposition]);
    const changePage = (currentPage) => {
        try {
            setCurrent(currentPage);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('分页切换异常,请重新配置数据源字段或更新组件');
        }
    };
    const onSort = (dataIndex, order) => {
        idata.sort((a, b) => {
            if (order === 'desc') {
                return a[dataIndex] - b[dataIndex];
            }
            else {
                return b[dataIndex] - a[dataIndex];
            }
        });
    };
    const cellrender = (_, index) => {
        const style = props.style[(current - 1) * (pageSize || 10) + index];
        const r = 2 * props.seqNumBackgroundsize + 'px';
        return (createElement("div", { style: {
                width: r,
                height: r,
                lineHeight: r,
                borderRadius: r,
                backgroundColor: style ? style.backgroundColor : 'transparent',
                margin: 'auto',
                display: 'inline-block',
            } },
            createElement("span", { style: { color: style ? style.numColor : '#000' } }, (current - 1) * (pageSize || 10) + index + 1)));
    };
    const highlights = [];
    const getComputedStyle = (rowIndex, colIndex, dataIndex, record) => {
        try {
            const merge = props?.code ? props?.code(rowIndex, colIndex) || {} : {};
            let bgc = {};
            const find = highlights.find((e) => e.props === dataIndex);
            if (find) {
                if (record[dataIndex] > find.threshold) {
                    bgc = {
                        style: {
                            backgroundColor: find.color,
                        },
                    };
                }
            }
            return {
                ...merge,
                ...bgc,
            };
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('单元格样式计算异常,请更新组件');
        }
    };
    const myExportExcel = async (param = false) => {
        try {
            if (dataSource?.cols.length) {
                const fl = dataSource?.filter || [];
                const params = {
                    searchType: 'EXPORT',
                    groupId: dataSource.dataset.id,
                    type: 'Table',
                    fieldList: dealFieldByList(dataSource.cols),
                    customFilterVo: param
                        ? {
                            logic: 'and',
                            filterVos: [
                                dataSource?.filter[0],
                                ...Object.entries(param).map((item) => {
                                    const [name, value] = item;
                                    const field = dataSource.f.find((e) => e.name === name);
                                    if (value != undefined && value != '' && String(value) !== ',') {
                                        return {
                                            filed: field?.fieldShortName,
                                            filterValue: String(value),
                                            customFilterVo: String(value),
                                            symbol: dealSymbol(field?.additional?.relationship, field?.additional?.searchType || 'fuzzyQuery'),
                                            valueType: field?.type,
                                            filterType: getSearchType(field?.additional?.searchType || 'fuzzyQuery'),
                                        };
                                    }
                                }),
                            ].filter((e) => e && e.filterValue),
                        }
                        : fl[0] === undefined
                            ? null
                            : {
                                logic: 'and',
                                filterVos: [dataSource?.filter[0] || null].filter((e) => e),
                            },
                };
                setLoading(true);
                exportData(params)
                    .then(async (res) => {
                    const reslut = await fetchApplication(appid);
                    const title = reslut.data.applicationName;
                    downloadFile(res, `${title}_表格`);
                })
                    .finally(() => {
                    setLoading(false);
                });
            }
            else {
                const reslut = await fetchApplication(appid);
                const title = reslut.data.applicationName;
                exportExcel(data.map((e, i) => ({ ...e, index: i + 1 })), cols, `${title}_表格`);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('导出异常,请重新配置数据源面板字段或更新组件');
        }
    };
    const init = (param = false) => {
        try {
            if (dataSource?.cols.length) {
                const fl = dataSource?.filter || [];
                const params = {
                    pageNum: current - 1,
                    pageSize,
                    groupId: dataSource.dataset.id,
                    type: 'Table',
                    fieldList: dealFieldByList(dataSource.cols),
                    customFilterVo: param
                        ? {
                            logic: 'and',
                            filterVos: [
                                dataSource?.filter[0],
                                ...Object.entries(param).map((item) => {
                                    const [name, value] = item;
                                    const field = dataSource.f.find((e) => e.name === name);
                                    if (value != undefined && value != '' && String(value) !== ',') {
                                        return {
                                            filed: field?.fieldShortName,
                                            filterValue: String(value),
                                            customFilterVo: String(value),
                                            symbol: dealSymbol(field?.additional?.relationship, field?.additional?.searchType || 'fuzzyQuery'),
                                            valueType: field?.type,
                                            filterType: getSearchType(field?.additional?.searchType || 'fuzzyQuery'),
                                        };
                                    }
                                }),
                            ].filter((e) => e && e.filterValue),
                        }
                        : fl[0] === undefined
                            ? null
                            : {
                                logic: 'and',
                                filterVos: [dataSource?.filter[0] || null].filter((e) => e),
                            },
                };
                previewDataByField(params)
                    .then((res) => {
                    const fields = res?.data?.fields;
                    if (!fields) {
                        Message.error(res?.msg);
                        return;
                    }
                    const minw = 50;
                    const maxw = 400;
                    const tempCols = dataSource.cols.map((e) => {
                        const list = [
                            e?.additional?.alias || e.name,
                            ...res.data.data.map((item) => item[e.fieldShortName]),
                        ];
                        let width = minw;
                        for (let i = 0; i < list.length; i++) {
                            const w = getTextWidth(list[i]) + 36;
                            if (width < w) {
                                width = Math.min(w, maxw);
                                if (width === 400)
                                    break;
                            }
                        }
                        return {
                            title: e?.additional?.alias || e.name,
                            dataIndex: e.fieldShortName,
                            width: `${width}px`,
                        };
                    });
                    setIdata(res.data.data.map((e, i) => ({ ...e, index: i + 1 })));
                    setIcols(tempCols);
                    setTotal(res.data.total);
                })
                    .finally(() => {
                    setLoading(false);
                });
            }
            else {
                setIdata(data.map((e, i) => ({ ...e, index: i + 1 })));
                setIcols(cols);
                setTotal(2);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('初始化数据出错,请在数据源面板重新配置字段或更新组件');
        }
    };
    const filterSearch = (param) => {
        try {
            if (dataSource?.cols.length && param) {
                pam.current = param;
                setLoading(true);
                init(param);
            }
            else {
                Message.show('暂无可查询数据!');
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('过滤查询出错,请更新数据源面板字段或更新组件');
        }
    };
    const filterReset = () => {
        try {
            pam.current = null;
            init();
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('查询重置出错,请更新数据源面板字段或更新组件');
        }
    };
    const [isMoble, setIsMoble] = useState(fIsMobile());
    const listenResize = () => {
        setIsMoble(fIsMobile());
    };
    useEffect(() => {
        window.addEventListener('resize', listenResize);
        return () => {
            window.removeEventListener('resize', listenResize);
        };
    }, []);
    const exporter = useRef();
    const exportImage = () => {
        setLoading(true);
        setTimeout(() => {
            dom2image(exporter.current, `${titleText || dataSource?.dataset?.name || '表格'}_${new Date().toLocaleString()}.png`).finally(() => {
                setLoading(false);
            });
        }, 40);
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, className: `table-${props.size} base_bg table` },
        createElement("div", { className: "flex-b" },
            hasTitle && dataSource?.dataset?.name ? (createElement("div", { className: "flex-s datasettitle" },
                createElement("div", null, titleText || dataSource?.dataset?.name),
                createElement(Tooltip, { v2: true, popupStyle: {
                        backgroundColor: '#1F2633',
                        color: '#fff',
                        borderRadius: '8px',
                    }, trigger: createElement("img", { style: { marginLeft: '8px' }, src: require('../../../assets/images/help.png'), alt: "" }) }, descText || '暂未配置描述'))) : (createElement("div", null)),
            isMoble ? null : (createElement("div", { className: "table_header" },
                createElement(Button, { className: "export_btn", onClick: () => myExportExcel(pam.current), type: "normal" },
                    createElement(Icon, { type: "download" }),
                    "\u5BFC\u51FA"),
                createElement(Button, { className: "export_btn img_btn", onClick: exportImage, type: "normal" },
                    createElement(Icon, { type: "download" }),
                    "\u5BFC\u51FA\u56FE\u7247")))),
        createElement(Loading, { visible: loading, fullScreen: true },
            createElement(TableHeader, { dataset: dataSource?.dataset || null, field: dataSource?.f, filterSearch: filterSearch, filterReset: filterReset, data: idata, icols: icols, isMoble: isMoble, exportExcel: () => myExportExcel(pam.current), setError: setError, setErrmsg: setErrmsg, exportImage: exportImage }),
            createElement("div", { style: { marginBottom: '14px' }, ref: exporter },
                createElement(Table.StickyLock, { dataSource: paging
                        ? transposition
                            ? itranspositionData
                            : idata
                        : transposition
                            ? itranspositionData
                            : idata, hasHeader: !transposition, fixedHeader: props.fixedHeader, maxBodyHeight: props.maxBodyHeight, isTree: props.isTree, isZebra: theme === 'zebra', hasBorder: theme === 'border', cellProps: (!transposition && getComputedStyle) || (() => { }), openRowKeys: openRowKeys, className: `${theme === 'noBorder' ? 'noBorder' : ''} ${transposition ? 'table-transposition' : ''}`, onRowOpen: (openRowKeys) => {
                        setOpenRowKeys(openRowKeys);
                    }, onSort: onSort, style: {
                        '--hbgc': headerBgColor || '#E4E7ED',
                        '--htc': headerTextColor || '#444',
                    } },
                    showSeqNum && !transposition ? (createElement(Table.Column, Object.assign({ cell: cellrender, width: props.seqNumColWidth, align: "center" }, (fixedColumnlndex
                        ? {
                            lock: 'left',
                        }
                        : {})))) : null,
                    renderCols())),
            paging ? (createElement("div", { className: "table-pagination" },
                createElement("span", { className: "table-count" },
                    "\u5171 ",
                    total,
                    " \u6761"),
                createElement(Pagination, { onChange: changePage, pageSize: pageSize || 10, showJump: props.showPageSelect, size: props.pagerSize, type: isMoble ? 'simple' : props.pagerType, current: current, pageShowCount: props.maxPagers, total: total || 0 }))) : null)))));
};
export default React.forwardRef(ITable);
